<script lang="ts">
	//UI
	import {
		HubProfileTextInput,
		DefaultButton,
		HubProfileBottomLineButton,
	} from "@hitit/new_ui";
	import Editicon from "@hitit/hub/src/assets/Icons/Edit.png";
	import Message from "@hitit/hub/src/v7/components/profile/Message.svelte";
	import CancelButton from "@hitit/hub/src/v7/components/profile/CancelButton.svelte";
	import ProfileInputFrame from "@hitit/hub/src/v7/components/profile/ProfileInputFrame.svelte";
	//Utils
	import { t, api } from "@hitit/hub/src/stores";
	//Types
	import type { ProfileData, UserData } from "@hitit/api";
	//Props
	export let user: UserData;
	export let profile: ProfileData;
	//Constants
	//Variables

	let sendingEmail = false;
	let loading = false;
	let editmode = false;

	let newPassword = "";
	let confirmPassword = "";

	let newPasswordError = "";
	let confirmPasswordError = "";
	//Functions

	function checkInputs() {
		newPasswordError = !/^[a-zA-Z\d@$!$*#?&]*$/.test(newPassword)
			? $t("hub.profile.password_error_invalid")
			: newPassword.length < 8
			? $t("hub.profile.password_error_8")
			: "";

		confirmPasswordError =
			newPassword !== confirmPassword
				? $t("hub.profile.password_confirm_error")
				: "";

		if (confirmPasswordError || newPasswordError) {
			return false;
		} else {
			return true;
		}
	}

	async function submitHandler() {
		try {
			//password checked
			if (!checkInputs()) {
				return;
			}
			loading = true;
			await $api.updateUser(
				Object.assign({}, user, { password: newPassword }),
				user.id
			);

			loading = false;
			resetAll();
		} catch (e) {
			newPasswordError = $t("sso.error.unknownError");
			//
		} finally {
			loading = false;
		}
	}

	async function sendResetPasswordEmail() {
		try {
			sendingEmail = true;
			await $api.requestPasswordResetEmail(user.username);
		} catch (error) {
			console.log(error);
		} finally {
			sendingEmail = false;
		}
	}

	function resetAll() {
		newPassword = "";
		confirmPassword = "";
		newPasswordError = "";
		confirmPasswordError = "";
		newPassword = "";
		confirmPassword = "";
		editmode = false;
	}

	$: saveButtonDisabled =
		confirmPasswordError ||
		confirmPassword.length === 0 ||
		newPassword.length === 0 ||
		loading
			? true
			: false;

	$: backgroundColor = saveButtonDisabled ? "#a5c1f9" : "#6b93f3";

	//Do
</script>

<form
	class:edit={editmode}
	on:submit|preventDefault={submitHandler}
	disabled={loading}
>
	{#if !editmode}
		<div class="frame">
			<ProfileInputFrame name={$t("hub.profile.password")}>
				<div class="password-box">
					<span class="value">*********</span>
					{#if !profile.cellphone?.includes("Azure")}
						<img
							class="edit-icon"
							src={Editicon}
							alt="Edit Password"
							on:click={() => (editmode = true)}
						/>

						<div class="send-email">
							<HubProfileBottomLineButton
								loading={sendingEmail}
								on:click={sendResetPasswordEmail}
								let:hover={emailSendHover}
							>
								<span class="email-send" class:hover={emailSendHover}>
									{$t("mbr.user.send_reset_password_mail")}
								</span>
							</HubProfileBottomLineButton>
						</div>
					{/if}
				</div>
			</ProfileInputFrame>
		</div>
	{:else}
		<div class="container">
			<div class="messageFrame newPassword">
				<ProfileInputFrame name={$t("hub.profile.new_password")}>
					<HubProfileTextInput
						on:input={() => (newPasswordError = "")}
						placeholder={$t("hub.profile.over_8")}
						error={newPasswordError !== ""}
						disabled={loading}
						password
						bind:value={newPassword}
					/>
				</ProfileInputFrame>
				<Message error messageTrnaslation={newPasswordError} />
			</div>
			<div class="messageFrame">
				<ProfileInputFrame name={$t("hub.profile.new_password_confirm")}>
					<HubProfileTextInput
						on:input={() => (confirmPasswordError = "")}
						placeholder={$t("hub.profile.over_8")}
						error={confirmPasswordError !== ""}
						disabled={loading}
						password
						bind:value={confirmPassword}
					/>
				</ProfileInputFrame>
				<Message error messageTrnaslation={confirmPasswordError} />
			</div>
		</div>
		<div
			class="button-box done"
			class:confirmPasswordError={confirmPasswordError}
		>
			<DefaultButton
				-password-save={true}
				fitmode
				background={backgroundColor}
				disabled={loading}
				isLoading={loading}
				on:click={submitHandler}
			>
				<span class="white">{$t("global.save")}</span>
			</DefaultButton>
		</div>
		<div class="cancelbox">
			<CancelButton on:click={resetAll} />
		</div>
	{/if}
</form>

<style lang="scss">
	@import "../../../variables.scss";

	:global(.-password-save) {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	div {
		box-sizing: border-box;
	}

	form {
		display: flex;
		flex-direction: column;
		position: relative;
		padding: 0 20px;
		gap: 10px;

		.frame {
			flex-grow: 1;

			.password-box {
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				align-items: center;
				gap: 10px 10px;
				flex-grow: 1;
				.edit-icon {
					width: 24px;
					height: 24.2px;
					&:hover {
						cursor: pointer;
					}
				}
				.value {
					max-width: calc(100% - 34px); /* 24 + gap */
					font-weight: 500;
					color: #46474b;
					flex-grow: 1;
					word-break: break-all;
				}

				.send-email {
					width: 100%;
					.email-send {
						font-weight: 200;
						font-size: 0.85rem;
						color: #3c68d6;

						&.hover {
							color: var(--default-hover-btn-1);
						}
					}
				}
			}
		}

		&.edit {
			background-color: #e6e7ed;
			padding: 20px 20px;
		}
		.messageFrame {
			display: flex;
			flex-grow: 1;
			flex-direction: column;
			gap: 6px;
		}

		.container {
			display: flex;
			flex-grow: 1;
			flex-direction: column;
			gap: 20px;
		}

		.button-box {
			flex-grow: 1;
			height: 32px;

			&.done {
				.white {
					font-size: 1rem;
					color: white;
				}
			}
			span {
				margin-top: -1px;
			}
		}
		.cancelbox {
			position: absolute;
			top: 10px;
			right: 10px;
		}
	}

	@include DesktopSize {
		form {
			flex-direction: row;
			position: relative;
			padding: 0 40px;
			gap: 20px;

			.cancelbox {
				position: absolute;
				top: 20px;
				right: 20px;
			}

			&.edit {
				background-color: #e6e7ed;
				padding: 20px 40px;
			}

			.messageFrame {
				gap: 10px;
				flex-grow: 0;
			}

			.container {
				flex-direction: column;
				gap: 20px;
				.password-box {
					flex-direction: row;
					flex-wrap: nowrap;
					gap: 10px;
					flex-grow: 1;
					.value {
						flex-grow: 0;
						font-size: 1.25rem;
						order: 1;
					}
					.edit-icon {
						order: 3;
					}
					.send-email {
						flex-grow: 1;
						width: auto;
						order: 2;

						.email-send {
							font-size: 1rem;
						}
					}
				}
			}
			.button-container {
				display: flex;
			}
			.button-box {
				min-width: 150px;
				flex-basis: 150px;
				flex-grow: 0;
				box-sizing: border-box;
				height: 40px;

				&.done {
					margin-top: auto;
					.white {
						font-size: 1.25rem;
					}
				}
				&.confirmPasswordError {
					margin-bottom: 25px;
				}
			}
		}
	}
</style>
